import { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getDiscountPrice } from "../../../helpers/product";
import { deleteFromCart } from "../../../store/slices/cart-slice";
import { useTranslation } from "react-i18next";

import ProductModal2 from "../../product/ProductModal2";
import { Lazy } from "swiper";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PropTypes from "prop-types";

const MenuCart = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const currency = useSelector((state) => state.currency);
  const { t, i18n } = useTranslation();
  const { cartItems } = useSelector((state) => state.cart);
  const { configParams } = useSelector((state) => state.paramsWeb);
  let cartTotalPrice = 0;
  const [modalShow, setModalShow] = useState(false);
  const cartRef = useRef(null);
  const navigate = useNavigate();

  const handleProductQuickView = async (e, product) => {
    navigate("/cart");
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); // Array de dependencias vacío para que solo se aplique al montar y desmontar

  function handleClickOutside(event) {
    if (cartRef.current && !cartRef.current.contains(event.target)) {
      onClose();
    }
  }

  return (
    <Fragment>
      <div
        className={`shopping-cart-content ${isOpen ? "active" : ""}`}
        ref={cartRef}
      >
        {cartItems && cartItems.length > 0 ? (
          <Fragment>
            <ul>
              {cartItems.map((item) => {
                const discountedPrice = getDiscountPrice(
                  item.price,
                  item.discount
                );
                const finalProductPrice = (
                  item.price * currency.currencyRate
                ).toFixed(2);

                const finalDiscountedPrice = (
                  discountedPrice * currency.currencyRate
                ).toFixed(2);

                discountedPrice != null
                  ? (cartTotalPrice += finalDiscountedPrice * item.quantity)
                  : (cartTotalPrice += finalProductPrice * item.quantity);

                return (
                  <li
                    key={item.cartItemId}
                    className={
                      item.isSoldOut
                        ? "sold-out single-shopping-cart"
                        : "single-shopping-cart"
                    }
                  >
                    <div className="shopping-cart-img d-flex px-3">
                      <button
                        id={item.id}
                        name={item.code}
                        type="button"
                        onClick={(e) => handleProductQuickView(e, item)}
                      >

                        <LazyLoadImage
                          alt={item.name}
                          src={
                            configParams.RUTAIMAGENESARTICULOS +
                              item?.images[0] ||
                            configParams.RUTAIMAGENESARTICULOS + item?.image
                          }
                          width={70}
                          className="img-fluid ml-4"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/default/no-image-thumbnail.avif";
                          }}
                        />
                      </button>
                    </div>
                    <div className="shopping-cart-title">
                      <h4 className="mb-2">
                        <span className="text-left text-black fs-6">
                          {" "}
                          {item.name}{" "}
                          <p>
                            <small className="text-xs text-muted">
                              {item.code}
                            </small>
                          </p>
                        </span>
                      </h4>

                      {!item.isSoldOut ? (
                        <h6 className="font-bold">
                          {t("page_cart.th_qty")}: {item?.quantity}
                        </h6>
                      ) : (
                        <h6 className="text-danger fw-bold">
                          {t("page_cart.th_qty")}:{" 0"}
                        </h6>
                      )}

                      <p>
                      <h6 className="d-flex justify-content-start align-items-center gap-2">
                        <span className="fw-bold">{"Precio"}</span>:
                        {" "}
                      {
                        discountedPrice !== null 
                          ? (
                            <div className="d-flex justify-content-between align-items-center gap-2">
                              <span className="muted">
                                <del>
                                {
                                  new Intl.NumberFormat(i18n.language, {
                                    style: "currency", 
                                    currency: currency.currencyName,
                                  }).format(finalDiscountedPrice)
                                }
                                </del>
                              </span>
                              {" "}
                              <span className="fw-bold">
                                {
                                  new Intl.NumberFormat(i18n.language, {
                                    style: "currency",
                                    currency: currency.currencyName,
                                  }).format(finalProductPrice)
                                }
                              </span>
                            </div>
                          )
                          : 
                            <span className="fw-bold">
                            {
                              new Intl.NumberFormat(i18n.language, {
                              style: "currency",
                              currency: currency.currencyName,
                              }).format(finalProductPrice)
                            }
                           </span>
                      }
                      </h6>
                      </p>  
                      <span className="">
                        {item.selectedProductColor &&
                        item.selectedProductSize ? (
                          <div className="cart-item-variation">
                            <h6>Color: {item.selectedProductColor}</h6>
                            <h6>
                              {t("general_words.size")}:{" "}
                              {item.selectedProductSize}
                            </h6>
                          </div>
                        ) : (
                          ""
                        )}
                      </span>
                    </div>

                    <div className="shopping-cart-delete">
                      <button
                        onClick={(e) => {
                          onClose();
                          dispatch(deleteFromCart(item.cartItemId));
                        }}
                      >
                        <i className="fa fa-times-circle" />
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
            <div className="shopping-cart-total">
              <h4 className="fw-bold fs-6 px-3">
                Total :{" "}
                <span className="shop-total">
                  {new Intl.NumberFormat(i18n.language, {
                    style: "currency",
                    currency: currency.currencyName,
                  }).format(cartTotalPrice)}
                </span>
              </h4>
            </div>
            <div className="shopping-cart-btn btn-hover text-center">
              <Link
                className="default-btn text-black fw-bold"
                to={process.env.PUBLIC_URL + "/cart"}
              >
                {t("general_words.view_cart")}
              </Link>
              <Link
                className="default-btn text-black fw-bold"
                to={process.env.PUBLIC_URL + "/checkout"}
              >
                {t("checkout")}
              </Link>
            </div>
          </Fragment>
        ) : (
          <p className="text-center">{t("no_items_cart")}</p>
        )}
      </div>
      <ProductModal2
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        currency={currency}
      />
    </Fragment>
  );
};

export default MenuCart;

MenuCart.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

MenuCart.defaultProps = {
  isOpen: false,
  onClose: () => {},
};
